import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TimelineFilters } from "../se-timeline.models";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';

@Component({
    selector: 'se-timeline-months-slider',
    templateUrl: './se-timeline-months-slider.component.html',
    styleUrls: ['./se-timeline-months-slider.component.scss'],
    standalone: true,
    imports: [CommonModule, MatSliderModule, FormsModule],

})
export class SeTimelineMonthsSliderComponent implements OnChanges {
    @Input() years : any[] = [{ date: '', description: '' }];
    @Output() filtersValue : EventEmitter<any> = new EventEmitter<any>();

    filters : TimelineFilters = { min: null, max: null, isMonthlyView: false };
    currentYear : number = 0;
    constructor () {

    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.years) {
            const year = this.years[0].date.split('-')[0];
            this.currentYear = Number(year);
        }
    }
 
    private convertToMonths (value : number) {
        switch (value) {
            case 0:
            case 1: case 2: case 3: case 4: case 5:
            case 6: case 7: case 8: case 9: case 10:
            case 11: case 12:
                return new Date(this.currentYear, value);
            default:
                return new Date();
        }
    }

    private buildFilters () {
        let minYear = this.filters.min || new Date(this.currentYear, 0);
        let maxYear = this.filters.max || new Date(this.currentYear, 11, 31);

        let filter = {
            min: minYear,
            max: maxYear,
            isMonthlyView: true
        };
        this.filtersValue.emit(filter);
    }

    private buildFiltersValueByMonth () {
        this.buildFilters();
    }

    _onStartMonthValueChange (event : any) {
        this.filters.min = this.convertToMonths(event);
        this.buildFiltersValueByMonth();
    }

    _onEndMonthValueChange (event : any) {
        this.filters.max = this.convertToMonths(event);
        this.buildFiltersValueByMonth();
    }
}
